import { Component, OnInit } from '@angular/core';
import {StoreCommonService} from '../../../../services/store/store-common.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-store-group',
    templateUrl: './store-group.component.html'
})
export class StoreGroupComponent implements OnInit {

    activeView = 0;
    labelButtonBack = '';
    storeGroup = null;

    constructor(public svc: StoreCommonService,
                private translate: TranslateService) {
    }

    ngOnInit() {
        this.translate.get([
            'common.back'
        ]).subscribe((res) => {
            this.labelButtonBack = res['common.back'];
        });
    }

    showGroupDetails(row) {
        this.activeView = row.id;
        this.storeGroup = row;
    }

    showList () {
        this.activeView = 0;
        this.storeGroup = null;
    }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-group/store-group.component.ts